<template>
  <!-- Add -->
  <b-modal
    id="modalProject"
    ref="my-modal"
    title="ข้อมูลโครงการ"
    size="xl"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    ok-only
    @show="resetModal"
  >
    <b-row v-if="items">
      <b-col lg="9">
        <b-form-group
          label="รหัสโครงการ"
          label-for="pj_code"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="pjcode"
              v-model="items.pj_code"
              type="text"
              placeholder="รหัสโครงการ"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="เลขที่สัญญา"
          label-for="contract_no"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="contractno"
              v-model="items.contract_no"
              type="text"
              placeholder="เลขที่สัญญา"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="12">
        <b-form-group
          label="ชื่อโครงการ"
          label-for="pjname"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="pj_name"
              v-model="items.pj_name"
              type="text"
              placeholder="ชื่อโครงการ"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="หน่วยงานที่เซ็นสัญญา"
          label-for="department"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="department"
              v-model="items.deptname"
              type="text"
              placeholder="หน่วยงาน"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="หน่วยงานที่รับผิดชอบ"
          label-for="department"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="department"
              v-model="items.Dept_Name"
              type="text"
              placeholder="หน่วยงาน"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-form-group
          label="ผู้ว่าจ้าง"
          label-for="vendor"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="vendor"
              v-model="items.vendor_name"
              type="text"
              placeholder="ผู้ว่าจ้าง"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="วันที่รับประกัน"
          label-for="guarantee date start"
        >
          <b-form-datepicker
            id="guarantee-date-start"
            v-model="items.guarantee_date_start_de"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            class="mb-2"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group
          label="วันสิ้นสุดค้ำประกัน"
          label-for="guarantee_date_end"
        >
          <b-form-datepicker
            id="guarantee-date-end"
            v-model="items.guarantee_date_end_de"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            class="mb-2"
            disabled
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-else>
      <div style="text-align: center; width: 100%; font-size: 20px">
        ยังไม่ได้เชื่อมต่อข้อมูล
      </div>

    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
  },
  data() {
    return {
      items: [],
    }
  },
  mounted() {
  },
  methods: {
    InfoProject(id) {
      axios
        .post('/infoProject', { wid: id })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetModal() {
      this.items = []
    },
  },
}
</script>
